<template>
    <ul class="nav_breadcrumbs">
        <li><router-link to="/modules/home">{{lang.LBL_HOME}}</router-link></li>
        <!--<li><router-link to="/modules/notifications/edit">{{lang.LBL_ADD_NOTIFICATION}}</router-link></li>!-->
        <li><router-link to="/modules/notifications">{{lang.LBL_VIEW_NOTIFICATION}}</router-link></li>
    </ul>
</template>
<script>
import lang from "@/views/modules/Notifications/language/en";
export default {
    name: "breadcrumbs",
    data() {
        return {
            lang:[],
           
        }
     },
     mounted() {
        this.lang = lang;
       
    },
    methods:{
       
    }
}
</script>
